// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file scopes/v1/ecom_scope.proto (package scopes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file scopes/v1/ecom_scope.proto.
 */
export const file_scopes_v1_ecom_scope: GenFile =
    /*@__PURE__*/
    fileDesc(
        'ChpzY29wZXMvdjEvZWNvbV9zY29wZS5wcm90bxIJc2NvcGVzLnYxKoIBCglFY29tU2NvcGUSGgoWRUNPTV9TQ09QRV9VTlNQRUNJRklFRBAAEh4KGkVDT01fU0NPUEVfT1RQX0NSRURJVF9SRUFEEAESHwobRUNPTV9TQ09QRV9PVFBfQ1JFRElUX1dSSVRFEAISGAoURUNPTV9TQ09QRV9BUFBTX1JFQUQQA0JqCg1jb20uc2NvcGVzLnYxQg5FY29tU2NvcGVQcm90b1ABWgQuL3BiogIDU1hYqgIJU2NvcGVzLlYxygIJU2NvcGVzXFYx4gIVU2NvcGVzXFYxXEdQQk1ldGFkYXRh6gIKU2NvcGVzOjpWMWIGcHJvdG8z'
    );

/**
 * @generated from enum scopes.v1.EcomScope
 */
export enum EcomScope {
    /**
     * @generated from enum value: ECOM_SCOPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,

    /**
     * @generated from enum value: ECOM_SCOPE_OTP_CREDIT_READ = 1;
     */
    OTP_CREDIT_READ = 1,

    /**
     * @generated from enum value: ECOM_SCOPE_OTP_CREDIT_WRITE = 2;
     */
    OTP_CREDIT_WRITE = 2,

    /**
     * @generated from enum value: ECOM_SCOPE_APPS_READ = 3;
     */
    APPS_READ = 3,
}

/**
 * Describes the enum scopes.v1.EcomScope.
 */
export const EcomScopeSchema: GenEnum<EcomScope> = /*@__PURE__*/ enumDesc(file_scopes_v1_ecom_scope, 0);
